import React from 'react';
import {
  Card,
  CardHeader,
  CardBody,
  TabContent, TabPane,
  Nav, NavItem, NavLink,
} from 'reactstrap';
import classnames from 'classnames';
import Waitable from '../../components/Waitable';
import { toast } from 'react-toastify';

import './JobQuote.css';
import FacilityToDestinationForm from '../../components/FacilityToDestinationForm/FacilityToDestinationForm';
import AccessorialsForm from '../../components/AccessorialsForm/AccessorialsForm';
import InvoiceForm from '../../components/InvoiceForm';
import FileSaver from 'file-saver';

export default class JobQuote extends React.Component {

  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      terminalId: null,
      orgId: null,
      terminalName: "",
      remarks: "",
      activeTab: '1',
      driverDetentionOptions: [],
      destinations: [],
      states: [],
      destination: "",
      state:"",
      zipCodes: []
    };

    this.submitPage1 = this.submitPage1.bind(this);
    this.submitPage2 = this.submitPage2.bind(this);
    this.submitPage3 = this.submitPage3.bind(this);
    this.submitJobRequest = this.submitJobRequest.bind(this);
    this.submitGetJobRequestPdf = this.submitGetJobRequestPdf.bind(this);

    this.onSelectedState = this.onSelectedState.bind(this);
    this.onSelectedTerminal = this.onSelectedTerminal.bind(this);
    this.onSelectedCity = this.onSelectedCity.bind(this);
    
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  submitPage1(formData) {
    let { accessorials } = this.props;

    let accessorialData = accessorials.get("data");
    if (accessorialData) {
      let filteredAccessorialData = accessorialData.filter(accessorial => {
        return accessorial.terminalId === formData.terminal.value;
      });

      let accessorials = filteredAccessorialData[0];
      let driverDetention = accessorials["Driver Detention"];
      let driverDetentionOptions = [];
      driverDetentionOptions = driverDetentionOptions.concat(Object.keys(driverDetention));

      let terminalId = (formData.terminal ? formData.terminal.value : "") || "";
      let terminalName = (formData.terminal ? formData.terminal.text : "") || "";
      //let terminalId = (formData.terminal ? formData.terminal.value : "") || "";
      //let terminalName = (formData.terminal ? formData.terminal.text : "") || "";

      this.setState({
        activeTab: "2",
        driverDetentionOptions,
        terminalId,
        terminalName
      });
    }

  }

  submitPage2(data) {
    let accessorials = Object.assign({}, data);
    delete accessorials['city'];
    delete accessorials['state'];
    delete accessorials['zip'];
    delete accessorials['terminal'];

    if (accessorials["Driver Detention"]) {
      let newKey = accessorials["Driver Detention"].value;
      accessorials["Driver Detention"] = {};
      accessorials["Driver Detention"][newKey] = accessorials["Driver Detention Hours"];
      delete accessorials["Driver Detention Hours"];
    }

    let { terminalId } = this.state;

    let parameters = {
      terminalId,
      orgId: data.orgId || "",
      quoteRequest: {
        destination: {
          city: data.city || "",
          state: (data.state ? data.state.value : "") || "",
          zip: parseInt(data.zip) || ""
        },
        accessorials
      }
    };

    let remarks = accessorials.remarks;

    const { dispatchCreateQuote } = this.props;
    dispatchCreateQuote(parameters, (err, result) => {
      if (err) {
        return toast.error(err.message);
      }
      this.setState({
        activeTab: "3",
        remarks
      });
    });

  }

  submitPage3(formData) {
    this.submitJobRequest(formData);
  }

  submitGetJobRequestPdf(quote){
    const { dispatchJobRequestPdf ,accessorials} = this.props;
    const { terminalName, remarks,  terminalId, zipCodes } = this.state

    quote.quote.baseRate.destination = terminalName + " to " + quote.quote.baseRate.destination;
    quote.remarks = remarks;

    let myAccessorials=accessorials.get("data") || false;
    if(myAccessorials){
      myAccessorials.forEach(access => {
        if(access.terminalId ===  terminalId){
          quote.note = access.Note;
        }
      })
    }

    dispatchJobRequestPdf(quote, (err, result) => {
      if (err) {
        toast.error(err.message);
     
      } else {
        toast.success("PDF is read");
        FileSaver.saveAs(result, "quote.pdf");
      }
    })
  }

  submitJobRequest(formData) {

    let { terminalId } = this.state;
    let { remarks } = this.state;
    let request = {
      quote: JSON.stringify(formData.quote),
      remarks,
      terminalId
    };

    let files = [];
    let entries = Object.entries(formData);
    entries.forEach(entry => {
      if (entry[0].includes("file")) {
        files.push(entry[1]);
      }
    });
    request.files = files;

    const { dispatchJobRequest } = this.props;
    dispatchJobRequest(request, (err, result) => {
      if (err) {
        toast.error(err.message);
      } else {
        toast.success("Success! Your job request has been submitted, a member from calhoun will be in touch with you shortly.");
      }
      this.setState({
        activeTab: "1"
      });

    });
  }

  onSelectedState(event, newValue, previousValue, name){
    const { dispatchGetZipCodes } = this.props;
    const {orgId, terminalId, state, destination} = this.state;

    console.log("onSelectedCity");
    this.setState({
      state: newValue
    }, () => {
      dispatchGetZipCodes({
        terminalId, orgId, state: newValue, destination
      },(err, result) =>{
        console.log(result);
        this.setState({
          zipCodes: result
        })
      })
    })

  }

  onSelectedCity(event, newValue, previousValue, name){

    const { dispatchGetZipCodes } = this.props;
    const {orgId, terminalId, state, destination} = this.state;

    console.log("onSelectedCity");
    this.setState({
      destination: newValue
    }, () => {
      dispatchGetZipCodes({
        terminalId, orgId, state, destination:newValue
      },(err, result) =>{
        console.log(result);
        this.setState({
          zipCodes: result
        })
      })
    })

    
  }

  onSelectedTerminal(data){
    console.log("onSelectedTerminal");
    console.log(data);

    const { dispatchGetDestinations,dispatchGetStates, self } = this.props;
    let  terminalId  =  data.value;
    let orgId = self.get("data") && self.get("data").organization ? self.get("data").organization._id : null;

    dispatchGetDestinations({
      terminalId, orgId
    },(err, result) =>{
      console.log(result);
      this.setState({
        destinations: result,
        terminalId,
        orgId
      })
    })

    dispatchGetStates({
      terminalId, orgId
    },(err, result) =>{
      console.log(result);
      this.setState({
        states: result,
        terminalId,
        orgId
      })
    })
  }

  render() {

    const { terminals, self, quote, jobRequest, accessorials } = this.props;
    const { terminalName, terminalId, zipCodes } = this.state;
    const { remarks } = this.state;
    let orgId = self.get("data") && self.get("data").organization ? self.get("data").organization._id : null;

    return (
      <div className="animated fadeIn">
        <Card>
          <CardHeader>
            <i className="fa fa-align-justify"></i><strong>Get Job Quote</strong>
          </CardHeader>
          <CardBody>
            <Waitable entities={[self, terminals]}>
              <Nav pills>
                <NavItem>
                  <NavLink
                    disabled={this.state.activeTab !== '1'}
                    className={
                      classnames({
                        active: this.state.activeTab === '1',
                        disabledNav: this.state.activeTab !== '1',
                        completedNav: this.state.activeTab === '2' || this.state.activeTab === '3'
                      })
                    }
                    onClick={() => { this.toggle('1'); }} >Terminal/Destination {' '}
                    {this.state.activeTab === '1' ? <i className="fa fa-arrow-circle-o-right" aria-hidden="true"></i> : null}
                    {this.state.activeTab === '2' || this.state.activeTab === '3' ? <i className="fa fa-check-circle-o" aria-hidden="true"></i> : null}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    disabled={this.state.activeTab !== '2'}
                    className={classnames(
                      {
                        active: this.state.activeTab === '2',
                        disabledNav: this.state.activeTab !== '2',
                        completedNav: this.state.activeTab === '3'
                      })}
                    onClick={() => { this.toggle('2'); }}>Accessorials {' '}
                    {this.state.activeTab === '2' ? <i className="fa fa-arrow-circle-o-right" aria-hidden="true"></i> : null}
                    {this.state.activeTab === '3' ?
                      <i className="fa fa-check-circle-o" aria-hidden="true"></i> : null}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    disabled={this.state.activeTab !== '3'}
                    className={classnames({
                      active: this.state.activeTab === '3',
                      disabledNav: this.state.activeTab !== '3'
                    })}
                    onClick={() => { this.toggle('3'); }}>Summary {' '}
                    {this.state.activeTab === '3' ? <i className="fa fa-stop-circle-o" aria-hidden="true"></i> : null}
                  </NavLink>
                </NavItem>
              </Nav>
              <TabContent activeTab={this.state.activeTab}>
                <TabPane tabId="1">
                  <FacilityToDestinationForm
                    form={"JobQuoteWizard"} // same form name
                    orgId={orgId}
                    onSubmit={this.submitPage1}
                    destinations={this.state.destinations}
                    states={this.state.states}
                    zipCodes={this.state.zipCodes}
                    onSelectedCity={this.onSelectedCity}
                    onSelectedState={this.onSelectedState}
                    onSelectedTerminal={this.onSelectedTerminal}
                    terminals={terminals.get("data") || []} />
                </TabPane>
                <TabPane tabId="2">
                  <AccessorialsForm
                    driverDetentionOptions={this.state.driverDetentionOptions}
                    remarks={this.state.remarks}
                    form={"JobQuoteWizard"} // same form name
                    previous={() => { this.toggle('1'); }}
                    onSubmit={this.submitPage2} />
                </TabPane>
                <TabPane tabId="3">
                  <Waitable entities={[quote, jobRequest]}>
                    <InvoiceForm
                      terminalId={terminalId}
                      accessorials={accessorials.get("data") || false}
                      quote={quote.get("data") || false}
                      terminalName={terminalName}
                      remarks={this.state.remarks}
                      initialValues={{
                        quote: quote.get("data") || false
                      }}
                      previous={() => { this.toggle('2'); }}
                      submitGetJobRequestPdf={this.submitGetJobRequestPdf}
                      onSubmit={this.submitPage3} />
                  </Waitable>
                </TabPane>
              </TabContent>
            </Waitable>
          </CardBody>
        </Card>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/views/Jobs/JobQuote.js